import {writable} from 'svelte/store';
import firebase from 'firebase';
import _ from 'lodash';
import moment from 'moment';
import {selectedChannelId} from "../channels/channelStore";

export const generateImageUploadPath = (userId, fileName) => {
  const now = new Date();
  return `/images/${userId}/${moment(now).format('YYYYMMDD')}/${now.getTime()}_${fileName}`;
};

export const getImageSize = url => new Promise((resolve, reject) => {
  const image = new Image();

  image.onload = () => {
    resolve(_.pick(image, ['width', 'height']));
  };

  image.onerror = () => reject(null);

  image.src = url;
});

/**
 * {
 *   [messageId]: [{
 *     file: File,
 *     uploadPath: ____, // will be used as a key for each file
 *     progress: 0 ~ 1
 *   }]
 * }
 */
export const uploadingImages = writable({});

export const uploadImages = async (messageId, files) => {
  const uploadingInfo = _.map(files, file => {
    const uploadPath = generateImageUploadPath(firebase.auth().currentUser.uid, file);
    return {
      file,
      uploadPath,
      progress: 0
    };
  });
  uploadingImages.update(val => ({
    ...val,
    [messageId]: uploadingInfo
  }));

  const promises = _.map(uploadingInfo, ({file, uploadPath}) => {
    const storageRef = firebase.storage().ref(uploadPath);

    const uploadTask = storageRef.put(file);

    uploadTask.on('state_changed', snapshot => {
      uploadingImages.update( val => ({
        ...val,
        [messageId]: _.map(val[messageId], info => {
          if (info.uploadPath !== uploadPath) return info;

          return {
            ...info,
            progress: (snapshot.bytesTransferred / snapshot.totalBytes) || 0
          }
        })
      }));
    });

    return uploadTask;
  });

  const snapshots = await Promise.all(promises);

  const images = await Promise.all(_.map(snapshots, async (s, i) => ({
    ..._.pick(s.metadata, ['fullPath', 'name', 'size', 'contentType']),
    downloadURLs: [await s.ref.getDownloadURL()],
    imageSize: await getImageSize(URL.createObjectURL(uploadingInfo[i].file))
  })));

  await firebase.firestore().collection('messages').doc(messageId).update({
    images
  });
  uploadingImages.set(_.omit(_uploadingImages, messageId));
};

// can edit only one message at once
export const editingMessageId = writable(null);

selectedChannelId.subscribe(() => editingMessageId.set(null));
